import { render, staticRenderFns } from "./SidebarItem.vue?vue&type=template&id=550488ab"
import script from "./SidebarItem.vue?vue&type=script&lang=js"
export * from "./SidebarItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\androidcode\\zf_tms_vue\\tms_vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('550488ab')) {
      api.createRecord('550488ab', component.options)
    } else {
      api.reload('550488ab', component.options)
    }
    module.hot.accept("./SidebarItem.vue?vue&type=template&id=550488ab", function () {
      api.rerender('550488ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/plain/sidebar/SidebarItem.vue"
export default component.exports